const FormFieldInput = ({
    type = 'text',
    label,
    fieldName,
    value,
    defaultValue,
    stateObject,
    updateStateObject,
    formatValue = null,
    className = '',
    onChange = null,
    additionalProps = {},
    readOnly = false,
    required = false,
    description = ''
}) => {
    const handleChange = (e) => {
        updateStateObject({
            ...stateObject,
            [fieldName]: formatValue ? formatValue(e.target.value) : e.target.value
        })

        if (onChange) {
            onChange(e)
        }
    }

    return (
        <div className={`formField ${className}`}>
            {label && <label>{label}{required ? "*" : ""}: </label>}
            {description && <span className="formField-description">{description}</span>}
            <input
                type={type}
                defaultValue={defaultValue}
                value={value}
                onBlur={handleChange}
                required={required}
                name={fieldName}
                {...additionalProps}
                readOnly={readOnly}
            />
        </div>
    )
}

export default FormFieldInput;